/**
 * Mutations for groups
 */
export const mutations = {
  // COMPLEX SETTERS

  /**
   * Set if the appointment is video
   * @param {Object} state
   * @param {Boolean} value
   */
  setIsVideo(state, value) {
    state.isVideo = value === true;
  },

  /**
   * Add an user to the list of selected users
   * @param {Object} state
   * @param {Object} value
   */
  addToSelected(state, value) {
    state.selected.push(value);
  },

  /**
   * Removing someone from the list of selected users
   * @param {Object} state
   * @param {Object} user
   */
  removeFromSelected(state, user) {
    // Step 1: Creating a new selected list
    const newSelected = state.selected.filter(curUser => {
      return !(curUser.id === user.id && curUser.type === user.type);
    });

    // Step 2: Setting the state
    state.selected = newSelected;
  },

  /**
   * Empty the selected list
   * @param {Object} state
   */
  clearSelected(state) {
    state.selected = [];
  },

  /**
   * Clear the state when changing page
   * @param {Object} state
   */
  clear(state) {
    state.isVideo = false;
    state.selected = [];
  }
};
